module.exports = "/_next/static/images/Hero-0991daafd4b37b519893cee1c6f1a0c9.webp";